import { buildDeptLocation } from './buildDeptLocation';
import { getPhone } from './getPhone';

/**
 * @param {ADDResponse} addResponse
 * @returns {WidgetLocation[]}
 */
export const buildLocations = (addResponse) => {
	const { address, primaryContactInformation } = addResponse;
	const { address1, address2, address3, city, country, postalCode, state } =
		address;

	// adding first address
	const addressToJoin = [address1, address2, address3];
	const defaultEmail =
		primaryContactInformation.email ||
		primaryContactInformation.email1 ||
		primaryContactInformation.email2;
	const defaultPhone = getPhone(addResponse) || '';
	const defaultAddress = {
		address: addressToJoin.filter(Boolean).join(' '),
		city,
		country,
		postalCode,
		state,
		type: 'default',
		hours: addResponse.hours,
		phones: [{ number: defaultPhone, type: 'Sales' }],
		timeZoneId: addResponse.timeZoneId,
		email: defaultEmail,
		departmentName: 'Sales'
	};

	const locations = buildDeptLocation(
		addResponse.departments,
		defaultAddress,
		primaryContactInformation
	);
	return locations;
};
